<template>

    <div class="w-100 row">
        <!-- Estatísticas por Método -->
        <div class="col-lg-6 mb-4">
            <div class="card shadow-sm border-0">
                <div class="card-header bg-gradient-primary text-white">
                    <h6 class="card-title mb-0">
                        <i class="fas fa-chart-bar mr-2"></i>
                        Estatísticas por Método (Últimos 30 dias)
                    </h6>
                </div>
                <div class="card-body p-0">
                    <div class="error-stats invisible-until-hover">
                        <div class="methods-grid">
                            <div
                                v-for="method in getMethodStatistics()"
                                :key="method.method"
                                class="method-card"
                            >
                                <div class="method-header">
                                    <div class="method-icon">
                                        <i :class="getMethodIcon(method.method)"></i>
                                    </div>
                                    <div class="method-info">
                                        <div class="method-name">{{ getMethodLabel(method.method) }}</div>
                                        <div class="method-total">{{ formatNumber(method.total) }} requisições</div>
                                    </div>
                                </div>

                                <div class="method-metrics">
                                    <div class="metrics-grid">
                                        <div class="metric-item success">
                                            <div class="metric-number">{{ method.success_count }}</div>
                                            <div class="metric-label">Sucessos</div>
                                        </div>
                                        <div class="metric-item error">
                                            <div class="metric-number">{{ method.error_count }}</div>
                                            <div class="metric-label">Erros</div>
                                        </div>
                                        <div class="metric-item rate">
                                            <div class="metric-number">{{
                                                    formatPercentage(method.success_rate)
                                                                       }}%
                                            </div>
                                            <div class="metric-label">Taxa</div>
                                        </div>
                                        <div class="metric-item time">
                                            <div class="metric-number">{{
                                                    formatExecutionTime(method.avg_execution_time)
                                                                       }}
                                            </div>
                                            <div class="metric-label">Tempo</div>
                                        </div>
                                    </div>

                                    <div class="method-progress">
                                        <div class="progress">
                                            <div
                                                class="progress-bar bg-success"
                                                :style="`width: ${method.success_rate}%`"
                                            ></div>
                                        </div>
                                        <div class="progress-label">
                                            {{ formatPercentage(method.success_rate) }}% de sucesso
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Estatísticas de Erro -->
        <div class="col-lg-6 mb-4">
            <div class="card shadow-sm border-0">
                <div class="card-header bg-gradient-secondary text-white">
                    <h6 class="card-title mb-0">
                        <i class="fas fa-exclamation-triangle mr-2"></i>
                        Tipos de Erro (30 dias)
                    </h6>
                </div>
                <div class="card-body p-0">
                    <div class="error-stats invisible-until-hover p-2">
                        <div
                            v-for="error in getErrorStatistics()"
                            :key="error.error_type"
                            class="error-item"
                        >
                            <div class="error-icon">
                                <i :class="getErrorIcon(error.error_type)"></i>
                            </div>
                            <div class="error-content">
                                <div class="error-title">{{ error.label }}</div>
                                <div class="error-count">{{ formatNumber(error.count) }} ocorrências</div>
                                <div
                                    class="error-time"
                                    v-if="error.avg_execution_time"
                                >
                                    Tempo médio: {{ formatExecutionTime(error.avg_execution_time) }}
                                </div>
                            </div>
                            <div
                                class="error-badge"
                                :class="getErrorTypeClass(error.error_type)"
                            >
                                {{ error.count }}
                            </div>
                        </div>
                        <div
                            v-if="getErrorStatistics().length === 0"
                            class="empty-state-small"
                        >
                            <i class="fas fa-thumbs-up fa-2x mb-2"></i>
                            <div>Nenhum erro no período</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import {
    formatExecutionTime,
    formatNumber,
    formatPercentage, getErrorIcon, getErrorTypeClass,
    getMethodIcon,
    getMethodLabel
} from "../../composables/mask";

export default {
    methods: {
        getErrorTypeClass,
        getErrorIcon,
        formatExecutionTime,
        formatPercentage,
        formatNumber,
        getMethodLabel,
        getMethodIcon,

        getMethodStatistics() {
            return this.statsData.method_statistics || [];
        },

        getErrorStatistics() {
            return this.statsData.error_statistics || [];
        },

    },
    props: {
        loadingStats: {
            type: Boolean,
            required: true
        },
        statsData: {
            type: Object,
            required: true
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/IntegrationLog/DetailedStats.vue